import { render, staticRenderFns } from "./Videoconsultation.vue?vue&type=template&id=203ec712&scoped=true"
import script from "./Videoconsultation.vue?vue&type=script&lang=js"
export * from "./Videoconsultation.vue?vue&type=script&lang=js"
import style0 from "./Videoconsultation.vue?vue&type=style&index=0&id=203ec712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203ec712",
  null
  
)

export default component.exports